<template>
  <div class="mt-3 ml-2 mr-2 caption">
    By using this service, you agree to the <v-btn small depressed @click="showTerms = true">Terms of Service</v-btn>.
    <v-dialog v-model="showTerms" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">Terms of service</v-card-title>
        <v-card-text>PBLMed.com reserves all rights to all content contained within pblmed.com. I will not save, duplicate, reproduce, distribute or otherwise share any pblmed.com content without written consent from the authors of pblmed.com (contact info@pblmed.com for permissions).
          Additionally, I understand that the pblmed.com platform is a resource or school/program curriculum, and I will access and use it in a manner consistent with, and which does not violate, individual school or program rules or procedures, or the spirit of those rules or procedures.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="green darken-1" text @click="showTerms = false">Ok</v-btn>
          <!-- <v-btn color="green darken-1" text @click="showTerms = false">Agree</v-btn> -->
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showTerms: false
    }
  }
}
</script>
<style scoped>
.link {
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/terms.vue